export const AssetUpload = {

	Name: "Asset Upload",

	Events: {

	},

	Actions: {

		"AssetUploads": function(assetUploadsByHierarchy, data) {

			if (data.AssetUploadsCreativeId) this.clearCreativeAssetUploads(data.AssetUploadsCreativeId);

			_.each(assetUploadsByHierarchy, assetUploads => {
				_.each(assetUploads, assetUpload => {

					this.setAssetUpload(assetUpload, assetUpload.id, !data.AssetUploadsCreativeId);

				});
			});

			if (data.AssetUploadsCreativeId) Broadcast.call("Creative Asset Uploads Loaded", [data.AssetUploadsCreativeId]);
			if (data.AssetUploadsCreativeId === Creative.SelectedCreative?.id) Broadcast.call("Selected Creative Asset Uploads Loaded");

		},

		"AssetUpload": function(assetUpload, data) {

			this.setAssetUpload(assetUpload, data.AssetUploadId); // AssetUploadId нужен потому что assetUpload может быть null - что означает что загрузку нужно удалить с клиента

		}

	},

	init() {

		this.AssetUploads = {}; // Хэш по id события
		this.AssetUploadsByHierarchy = {}; // группировка по id креатива -> codename ассета -> id загрузки

	},

	getCreativeAssetUploads(creativeId) {

		let result = [];

		this.forEachCreativeAssetUploads(creativeId, assetUpload => {

			result.push(assetUpload);

		});

		result = _.orderBy(result, 'start_time', 'desc');

		return result;

	},

	setAssetUpload(assetUpload, assetUploadId = null, isBroadcast = true) {

		let oldAssetUpload = this.AssetUploads[assetUploadId];

		if (assetUpload) {

			this.AssetUploads[assetUpload.id] = assetUpload;

			if (!this.AssetUploadsByHierarchy[assetUpload['creative_id']]) this.AssetUploadsByHierarchy[assetUpload['creative_id']] = {};
			if (!this.AssetUploadsByHierarchy[assetUpload['creative_id']][assetUpload['asset_codename']]) this.AssetUploadsByHierarchy[assetUpload['creative_id']][assetUpload['asset_codename']] = {};
			this.AssetUploadsByHierarchy[assetUpload['creative_id']][assetUpload['asset_codename']][assetUpload.id] = assetUpload;

			assetUpload['date'] = new Date(assetUpload['date']);

		} else if (oldAssetUpload) {

			delete this.AssetUploads[oldAssetUpload.id];

			if (this.AssetUploadsByHierarchy[oldAssetUpload?.['creative_id']]?.[oldAssetUpload?.['asset_codename']]) delete this.AssetUploadsByHierarchy[oldAssetUpload['creative_id']][oldAssetUpload['asset_codename']][assetUploadId];

		}

		if (isBroadcast) {

			let generationPrefixes = ["Asset Upload"];
			if (oldAssetUpload?.["creative_id"] === Creative.SelectedCreative?.id || assetUpload?.["creative_id"] === Creative.SelectedCreative?.id) generationPrefixes.push("Selected Creative Asset Upload");

			// Определяем автоматически изменения в объектах и запускаем соответствующие события
			this.broadcastChanges(oldAssetUpload, assetUpload, generationPrefixes);

		}

	},

	clearCreativeAssetUploads(creativeId) {

		_.each(this.AssetUploads, assetUpload => {

			if (assetUpload["creative_id"] === creativeId) delete this.AssetUploads[assetUpload.id];

		});

		if (this.AssetUploadsByHierarchy[creativeId]) delete this.AssetUploadsByHierarchy[creativeId];

	},

	forEachCreativeAssetUploads(creativeId, callback) {

		_.each(this.AssetUploadsByHierarchy[creativeId], assetUploads => {
			_.each(assetUploads, assetUpload => {

				callback(assetUpload);

			});
		});

	}

};

